import React from 'react';
import { Typography, AppBar } from '@material-ui/core';
import useStyles from './styles';
import VideoPlayer from './components/VideoPlayer';
import Sidebar from './components/Options';
import Notifications from './components/Notifications';

const App = () => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <AppBar className={classes.appBar} position="static" color="inherit">
        <Typography variant="h5" align="center">LET&apos;S CONNECT</Typography>
      </AppBar>
      <VideoPlayer />
      <Sidebar>
        <Notifications />
      </Sidebar>
    </div>
  );
};

export default App;
